import index from "./dialog.vue";
export default index;
